import { Button } from "@mui/material";
import React, { FunctionComponent, useState } from "react";
import Popup from "../../popup/Popup";
import styles from "../styles/Components.css";
import { AppStore } from "../../../AppStore";

interface Props {
  onDelete: () => void;
  requireConfirm?: boolean;
  title?: string
  text?: string;
}

export const DeleteUtility: FunctionComponent<Props> = (props) => {
  const [state, actions] = AppStore.systems.use();
  const [showConfirmDelete, setShowConfirmDelete] = useState(false);

  const handleDelete = () => {
    if (props.requireConfirm) setShowConfirmDelete(true);
    else props.onDelete()
  };

  const handleConfirm = () => {
    props.onDelete()
    setShowConfirmDelete(false);
  }

  return (
    <div>
      <Button 
        style={{ backgroundColor: "#055D9C", color: 'white' }}
        className={styles.deleteButton}
        variant="outlined"
        onClick={handleDelete}
      >
        {props.text ? props.text : 'delete'}
      </Button>
      {props.requireConfirm && (
        <Popup
          subtitle={props.title}
          visible={showConfirmDelete}
          onDismiss={() => setShowConfirmDelete(false)}
        >
          <br />
          <div className={styles.submitButtonContainer}>
            <Button variant="outlined" color="error" onClick={handleConfirm}>
              confirm
            </Button>
          </div>
        </Popup>
      )}
    </div>
  );
};
